import React from "react";
//Icons
import MatchIcon from 'react-icons/lib/md/insert-link';

import ToolTipItem from "../utils/tooltip";
 import ServerPaginatedTable from "../utils/pagination.server";
import {appHelpers} from "../../_helpers";

const MatchedPaymentTableStructure = ({data, matchCallback}) => (
    <table className="table table-striped table-hover">
        <thead>
        <tr>
            <th>Airline (Issuer)</th>
            <th>Invoice Date</th>
             <th>Invoice Amount</th>
             <th>Action</th>
        </tr>
        </thead>
        <tbody>
        {data.map((item, i) =>
            <tr key={i}>
                <td className='text-capitalize'>
                    { item.LegacyCode }
                </td>
                <td>
                    {
                        (item.InvoiceDate) &&
                        <span>
                            {appHelpers.formatDate(item.InvoiceDate)}
                        </span>
                    }
                    {
                        (!item.InvoiceDate) &&
                        <i>
                            No Date
                        </i>
                    }
                 </td>
                <td>
                    { `${String.fromCharCode(appHelpers.getCurrencyUnicode(item.InvoiceCurrency))}${appHelpers.numberWithCommas(item.NetAmountCurrency)}` }
                </td>
                <td>
                <span className="text-primary pointer" onClick={(e) => matchCallback(item)}>
                   <ToolTipItem key={i + 'matchPayment'} title={<MatchIcon size="15" color="#43a8df"/>} content='Match Payment' id={i + 'matchPayment'}/>
                </span>
                </td>
            </tr>)}
        </tbody>
    </table>
);
class MatchedRecords extends React.Component {
    render() {
        let { data, pageSize, currentPage, totalMatchPaymentsCount, matchCallback, pageDataCallBack } = this.props;
        return (
            <div>
                <ServerPaginatedTable currentPage={currentPage} fetchMore={pageDataCallBack} target={<MatchedPaymentTableStructure matchCallback={matchCallback} data={data}/>} pageSize={pageSize} totalCount={ totalMatchPaymentsCount }/>
            </div>
        )
    }
}
export default MatchedRecords;



// WEBPACK FOOTER //
// ./src/views/matchPayment/matched-records.js